// extracted by mini-css-extract-plugin
module.exports = {"modal":"MultiTeamSelectModal_modal__F9M5W","teamsList":"MultiTeamSelectModal_teamsList__3TXiJ"};